import React, { useState, useEffect } from 'react';

const colors = {
  primary: '#1a1a1a',
  secondary: '#4c956c',
  accent: '#d9f2b4',
  light: '#f8faf5',
  neutral: '#336F4D',
  neutralLight: '#505151',
  cream: '#fffaf0',
  gold: '#d4af37',
  textDark: '#333'
};

export default function QAPage() {
  const [openCategoryIndex, setOpenCategoryIndex] = useState(null);
  const [openQuestionIndex, setOpenQuestionIndex] = useState({});
  const [animatedElements, setAnimatedElements] = useState({});

  // 分類常見問題（含子問題）
  const categoryFaqData = [
    {
      categoryTitle: '胞泌體煥膚常見 QA',
      categoryColor: '#4d9a6eff',
      questions: [
        {
          question: 'Q1：什麼是胞泌體煥膚？',
          answer: '胞泌體煥膚是利用胞泌體中所含的生長因子與活性分子，幫助肌膚調理環境、舒緩敏感，並促進肌膚代謝與修復，讓膚況逐步回到健康平衡狀態。'
        },
        {
          question: 'Q2：適合哪些膚質？',
          answer: '胞泌體煥膚適合大多數膚質，特別是：\n✔️ 膚色暗沉、粗糙\n✔️ 毛孔明顯\n✔️ 膚質敏弱、泛紅\n✔️ 想要溫和保養、改善膚況的人'
        },
        {
          question: 'Q3：療程會不會痛？需要恢復期嗎？',
          answer: '胞泌體煥膚使用專業美膚儀深入肌膚底層，過程溫和舒適，不需要恢復期。少數人可能會有短暫微紅，通常很快就能消退。'
        },
        {
          question: 'Q4：多久可以看到效果？',
          answer: '部分人於療程後 1-2 週會感受到膚質變得更細緻、保濕度提升。若搭配課程連續進行，膚況穩定度與光澤感會更明顯。'
        },
        {
          question: 'Q5：胞泌體煥膚和一般煥膚有什麼不同？',
          answer: '傳統煥膚大多以酸類代謝角質為主，可能會有刺激感；胞泌體煥膚則偏向「修護＋代謝並進」，在幫助代謝老廢角質的同時，也能提升肌膚自我修復力，降低敏感不適。'
        },
        {
          question: 'Q6：胞泌體煥膚有副作用嗎？',
          answer: '目前研究與臨床應用顯示，胞泌體煥膚屬於安全性高的療程，沒有已知副作用。但若您有特殊過敏或正在接受醫療治療，建議先與專業人員討論。'
        },
        {
          question: 'Q7：建議多久做一次？',
          answer: '一般建議每 2-3 週一次，持續 3-5 次為一個完整課程。實際狀況會依個人膚況調整。'
        },
        {
          question: 'Q8：請問課程結束可以上妝嗎？',
          answer: '可以，我們使用胞泌體專用的美膚儀器，不會有修復期或不能上妝的問題，敷完面膜當下就能塗抹保養品和上妝'
        },
        {
          question: 'Q9：請問京采使用的胞泌體與他牌胞泌體有什麼差別？',
          answer: '京采一律採用韓國原裝進口胞泌體，韓國在專研植物胞泌體多年，其使用的成分及專利技術非常穩定安全，並取得ISO22716:2007及FDA等相關認證'
        },
      ]
    },
    {
      categoryTitle: '胞泌體育髮常見 QA',
      categoryColor: '#336f4dff',
      questions: [
        {
          question: 'Q1：課程需要多少次？',
          answer: '每個人的落髮狀況不同，建議需經專業檢測後規劃。\n一般參考數據：雄性禿 1–4 期：建議至少 4–6 個月療程，平均每 2 週一次\n女性髮線分開、瀰漫式稀疏：平均每 2–3 週一次'
        },
        {
          question: 'Q2：課程費用怎麼計算？',
          answer: '單次費用約 NT$6,600起。實際次數依個人狀況而異，建議進行免費諮詢，才能規劃最合適的方案'
        },
        {
          question: 'Q3：誰適合做胞泌體育髮？',
          answer: '大多數有落髮、頭皮困擾的人都適合，但若有以下狀況，建議先與醫師討論：\n✔️ 頭皮長期感染（反覆發炎、真菌感染）\n✔️ 懷孕或哺乳中\n✔️ 癌症患者、化療或放射性治療中\n✔️ 已知對胞泌體成分過敏'
        },
        {
          question: 'Q4：需要恢復期嗎？',
          answer: '不需要！與植髮手術不同，胞泌體育髮屬於非侵入性療程，沒有傷口、不需恢復期，療程後即可正常生活。'
        },
        {
          question: 'Q5：需要停止使用其他生髮用品嗎？',
          answer: '不一定要停止，但通常不再需要。因為胞泌體本身具有抗發炎與活化毛囊的作用，能取代大部分傳統生髮用品'
        },
        {
          question: 'Q6：會有副作用嗎？',
          answer: '目前臨床案例顯示，胞泌體育髮幾乎沒有副作用，僅可能出現短暫紅潤，通常很快消退'
        },
        {
          question: 'Q7：多久能看到效果？',
          answer: '🔴 初步期（1–2 個月）：可能肉眼可見落髮減緩、髮絲增粗。\n🟡 中期（約 6 個月內）：胞泌體在組織內活性約 6–8 個月，需持續療程以維持效果。\n🟢 後續期（6 個月以上）：效果可延長，但仍需定期保養與維護，幫助毛囊維持活性。'
        },
      ]
    }
  ];

  const toggleCategory = (index) => {
    setOpenCategoryIndex(openCategoryIndex === index ? null : index);
    // 重置該分類下的所有子問題
    if (openCategoryIndex !== index) {
      setOpenQuestionIndex(prev => ({ ...prev, [index]: null }));
    }
  };

  const toggleQuestion = (categoryIndex, questionIndex) => {
    setOpenQuestionIndex(prev => ({
      ...prev,
      [categoryIndex]: prev[categoryIndex] === questionIndex ? null : questionIndex
    }));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimatedElements((prev) => ({ ...prev, qa: true }));
          }
        });
      },
      { threshold: 0.1 }
    );
    const section = document.getElementById('qa');
    if (section) observer.observe(section);
    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <section
      id="qa"
      className="qa-section animate-on-scroll"
      style={{
        padding: '6rem 2rem',
        background: 'linear-gradient(180deg, rgba(255,250,240,0.7) 0%, rgba(248,250,245,0.9) 100%)',
        fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
        color: colors.textDark,
        minHeight: '100vh'
      }}
    >
      <div style={{
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        {/* Header Section */}
        <h2
          style={{
            fontSize: '2rem',
            fontWeight: 600,
            textAlign: 'center',
            color: colors.primary,
            marginBottom: '1rem',
            animation: animatedElements['qa'] ? 'fadeInUp 1s ease forwards' : 'none',
            opacity: animatedElements['qa'] ? 1 : 0,
            fontFamily: "'Noto Serif TC','Cormorant Garamond', serif",

          }}
        >
          常見問題
        </h2>

        {/* Decorative Line */}
        <div style={{
          width: 'min(500px, 80%)',
          height: '2px',
          background: 'linear-gradient(90deg, #5C8989, rgba(92, 137, 137, 0.3))',
          margin: '0 auto 1rem',
          borderRadius: '1px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '50%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
            animation: 'shine 3s infinite'
          }} />
        </div>

        {/* Description */}
        <p style={{
          fontSize: 'clamp(1rem, 2vw, 1.1rem)',
          color: colors.neutralLight,
          maxWidth: '600px',
          margin: '0 auto 4rem',
          lineHeight: '1.7',
          fontWeight: 500,
          textAlign: 'center',
          padding: '0 1rem',
          animation: animatedElements['qa'] ? 'fadeIn 1.2s ease 0.3s forwards' : 'none',
          opacity: animatedElements['qa'] ? 1 : 0
        }}>
          以下是顧客最常詢問的問題，若您有其他疑問也歡迎聯絡我們。
        </p>


        {/* 分類問題區塊 */}
        <div>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem'
          }}>
            {categoryFaqData.map((category, catIndex) => (
              <div
                key={catIndex}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: openCategoryIndex === catIndex
                    ? '0 12px 32px rgba(76, 149, 108, 0.2)'
                    : '0 6px 20px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: `3px solid ${openCategoryIndex === catIndex ? category.categoryColor : 'transparent'}`,
                  animation: `fadeInUp 0.8s ease ${catIndex * 0.15}s forwards`,
                  opacity: 0,
                  animationFillMode: 'forwards'
                }}
              >
                {/* 分類標題按鈕 */}
                <button
                  onClick={() => toggleCategory(catIndex)}
                  style={{
                    background: `linear-gradient(135deg, ${category.categoryColor} 0%, ${category.categoryColor} 100%)`,
                    border: 'none',
                    width: '100%',
                    padding: '2rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease',
                    color: 'white'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.01)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.5rem'
                  }}>

                    <div style={{ textAlign: 'left' }}>
                      <h4 style={{
                        fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
                        fontWeight: 700,
                        margin: 0,
                        letterSpacing: '0.5px',
                        fontFamily: "'Noto Serif TC','Cormorant Garamond', serif",

                      }}>
                        {category.categoryTitle}
                      </h4>
                      <p style={{
                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                        margin: '0.5rem 0 0 0',
                        opacity: 0.9
                      }}>
                        {category.questions.length} 個常見問題
                      </p>
                    </div>
                  </div>

                  <div style={{
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                    transition: 'all 0.4s ease',
                    transform: openCategoryIndex === catIndex ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9L12 15L18 9" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </button>

                {/* 子問題列表 */}
                <div style={{
                  maxHeight: openCategoryIndex === catIndex ? '3000px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                  backgroundColor: colors.light
                }}>
                  <div style={{
                    padding: '2rem'
                  }}>
                    {category.questions.map((question, qIndex) => (
                      <div
                        key={qIndex}
                        style={{
                          marginBottom: qIndex < category.questions.length - 1 ? '1rem' : '0',
                          backgroundColor: colors.cream,
                          borderRadius: '10px',
                          overflow: 'hidden',
                          border: `2px solid ${openQuestionIndex[catIndex] === qIndex ? category.categoryColor : 'transparent'}`,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <button
                          onClick={() => toggleQuestion(catIndex, qIndex)}
                          style={{
                            background: 'none',
                            border: 'none',
                            width: '100%',
                            padding: '1.2rem 1.5rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            textAlign: 'left',
                            transition: 'background-color 0.3s ease',
                            backgroundColor: openQuestionIndex[catIndex] === qIndex
                              ? 'rgba(76, 149, 108, 0.05)'
                              : 'transparent'
                          }}
                        >
                          <span style={{
                            fontSize: 'clamp(0.95rem, 2vw, 1.1rem)',
                            fontWeight: 600,
                            color: colors.primary,
                            flex: 1,
                            paddingRight: '1rem'
                          }}>
                            {question.question}
                          </span>
                          <div style={{
                            width: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            backgroundColor: openQuestionIndex[catIndex] === qIndex ? category.categoryColor : colors.light,
                            color: openQuestionIndex[catIndex] === qIndex ? 'white' : category.categoryColor,
                            transition: 'all 0.3s ease',
                            transform: openQuestionIndex[catIndex] === qIndex ? 'rotate(180deg)' : 'rotate(0deg)',
                            flexShrink: 0
                          }}>
                            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                              <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                        </button>

                        <div style={{
                          maxHeight: openQuestionIndex[catIndex] === qIndex ? '1000px' : '0',
                          overflow: 'hidden',
                          transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease',
                          opacity: openQuestionIndex[catIndex] === qIndex ? 1 : 0
                        }}>
                          <div style={{
                            padding: '0 1.5rem 1.5rem 1.5rem',
                            fontSize: 'clamp(0.9rem, 1.8vw, 1rem)',
                            lineHeight: '1.8',
                            color: colors.textDark,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            borderTop: `1px solid ${colors.accent}`,
                            whiteSpace: 'pre-line',
                            textAlign: 'left'
                          }}>
                            {question.answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes shine {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }

        @media (max-width: 768px) {
          #qa {
            padding: 4rem 1rem !important;
          }
        }

        @media (max-width: 480px) {
          #qa {
            padding: 3rem 1rem !important;
          }
        }
      `}</style>
    </section>
  );
}